import Explain from "@/components/Explain";
import {
	safeGet
} from "@/utils";

import ErrorPlugin from './utils/errorPlugin.js'
import Vue from "vue";
import App from "./App.vue";
import "./request";
import request from "./request";
import router from "./router";
import store from "./store";
import "./style/index.scss";
import {
	getAuthUrl
} from "./utils";
import "./utils/mdx-plugin";

Vue.use(ErrorPlugin)

// import Video from 'video.js'
// import 'video.js/dist/video-js.css'
// Vue.prototype.$video = Video

import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css');
require('vue-video-player/src/custom-theme.css');
require('./style/my-player.css');
Vue.use(VideoPlayer)

import VueCoreVideoPlayer from 'vue-core-video-player'
Vue.use(VueCoreVideoPlayer, {
	lang: 'zh-CN'
})
Vue.config.productionTip = false;
Vue.component("g-explain", Explain);
Vue.config.ignoredElements = ['wx-open-launch-weapp']
Vue.prototype.$safeGet = safeGet;
(function() {
	// localStorage.setItem('web_uid',101408);
	const url = new URL(location.href);
	const code = url.searchParams.get("code");
	const jid = url.searchParams.get("jid");
	const path = url.searchParams.get("path");
	const code_type = url.searchParams.get("code_type");
	const jd_top = url.searchParams.get("jd_top");
	const web_uid = url.searchParams.get("web_uid");
	if(jd_top){
		localStorage.setItem('jd_top',jd_top);
	}
	if(code_type){
		localStorage.setItem('code_type',code_type);
	}
	if(jid){
		localStorage.setItem('jid',jid || 1);
	}
	if(web_uid){
		localStorage.setItem('web_uid',web_uid);
	}
	if(path){
		if(jid==37){
			localStorage.setItem('path',path || 'pages/map/map?jid=37')
		}else{
			localStorage.setItem('path',path || 'pages/index/index')
		}
	}
	const fn = () => {
		getAuthUrl().then(({
			url
		}) => {
			window.location.replace(url);
		});
	}
	if(localStorage.getItem('web_uid')){
		const useObj = {
			id: localStorage.getItem('web_uid'),
			phone: localStorage.getItem('phone')
		};
		store.commit("SET_USER", useObj);
		initWX()
		return
	}
	if(code){
		request.post(
			"/wx/WxLogin", {
				code: code
			}, {
				slient: true,
			}
		)
		.then((res) => {
			const useObj = {
				id: res.web_uid,
				phone: res.phone
			};
			localStorage.setItem('web_uid',res.web_uid)
			localStorage.setItem('phone',res.phone)
			store.commit("SET_USER", useObj);

			initWX()
		})
	}else{
		return fn()
	}
	function initWX(){
		let sign_url = '';
		if (window.__wxjs_is_wkwebview === true) {
			//如果当前设备是IOS
			sign_url = window.location.href.split('#')[0];
		}else{
			//非IOS设备
			sign_url = window.location.href;
		}
		request.post(
			"/wx/Signature", {
				url: encodeURIComponent(sign_url),
				memberId: localStorage.getItem('web_uid')
			}, {
				slient: true,
			}
		)
		.then((config) => {
			window.wx.config({
				debug: config.debug || false,
				nonceStr: config.noncestr,
				signature: config.signature,
				appId: config.appid,
				timestamp: config.timestamp,
				jsApiList: [
					"chooseWXPay",
					'chooseImage',
					'previewImage',
					"getLocation",
					"updateAppMessageShareData",
					"updateTimelineShareData",
					"onMenuShareAppMessage",
					"onMenuShareTimeline",
				],
				openTagList: ['wx-open-launch-weapp'],
			});

			request.post(
				"/wx/GetShareInfo", {
					jid: localStorage.getItem('jid')
				}, {
					slient: true,
				}
			)
			.then((shareData) => {
				var share = {
					title: shareData.name, // 分享标题
					desc: shareData.text, // 分享描述
					link: window.location.href, //url.origin, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
					imgUrl: shareData.image, // 分享图标
					success: function() {

					}
				};
				window.wx.ready(() => {
						window.wx.onMenuShareAppMessage(share);
						window.wx.onMenuShareTimeline(share);
						window.wx.updateAppMessageShareData(share);
						window.wx.updateTimelineShareData(share);
					window.wx.checkJsApi({
						jsApiList:[
							"chooseWXPay",
							'chooseImage',
							'previewImage',
							"getLocation",
							"updateAppMessageShareData",
							"updateTimelineShareData",
							"onMenuShareAppMessage",
							"onMenuShareTimeline",
						],
						openTagList: ['wx-open-launch-weapp'],
						success:function(res){
							console.log("支付调取sss",res)
						},
						fail:function(res){
							console.log("支付调取fffffff",res)
						}
					})
				});

			})

			return new Promise((r) => {
				window.wx.ready(r);
			});
		})
		.then(init);
	}
	
})();

function init() {
	window.app = new Vue({
		data: {
			id: 1,
		},
		router,
		store,
		render: (h) => h(App),
	}).$mount("#app");
}
